import { Skeleton } from '@mercai/clever'
import { useEffect, useRef, useState } from 'react'

import { useSaleOrderVariantList } from '@/services'

import { DropDownSearch, InputSearch } from './components'

import type { SaleOrderProps } from '@/types'

import type { SaleOrderSearchProps } from './sale-order-search.type'

import styles from './sale-order-search.module.css'

export const SaleOrderSearch = ({
  onSelect,
  selected,
  error,
  maxHeightDropdown,
  title,
  filters = {},
}: SaleOrderSearchProps) => {
  const [value, setValue] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const { data, isLoading } = useSaleOrderVariantList({
    variantFields: 'simplifiedList',
    limit: 10,
    ...filters,
    search: value,
  })

  const onChangeValue = (newValue: string) => {
    setValue(newValue)

    if (selected?.uuid) {
      onSelect({})
    }
  }

  const onHandleSelect = (valueParam: SaleOrderProps) => {
    setIsOpen(false)
    onSelect(valueParam)
  }

  useEffect(() => {
    if (selected?.reference) {
      setValue(selected?.reference)
    }

    return () => {
      setValue('')
    }
  }, [selected])

  const rootRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const closeOpennedDropDown = (e: MouseEvent) => {
      if (
        rootRef.current &&
        isOpen &&
        !rootRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener('mousedown', closeOpennedDropDown)

    return () => document.removeEventListener('mousedown', closeOpennedDropDown)
  }, [isOpen, rootRef])

  return (
    <div className={styles.core} ref={rootRef}>
      {isLoading && !isOpen ? (
        <div className={styles['wrap-skeleton']}>
          <Skeleton width="70%" height="1.25rem" />
          <Skeleton width="100%" height="2.5rem" />
        </div>
      ) : (
        <InputSearch
          onChange={onChangeValue}
          value={value}
          onOpen={setIsOpen}
          error={error}
          title={title}
        />
      )}

      <DropDownSearch
        isOpen={isOpen}
        data={data?.data?.results}
        isLoading={isLoading}
        onSelect={onHandleSelect}
        selected={selected}
        maxHeight={maxHeightDropdown}
      />
    </div>
  )
}
